import { render, staticRenderFns } from "./SettingUpdate.vue?vue&type=template&id=a8bbfe0c&scoped=true&"
import script from "./SettingUpdate.vue?vue&type=script&lang=js&"
export * from "./SettingUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SettingUpdate.vue?vue&type=style&index=0&id=a8bbfe0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bbfe0c",
  null
  
)

export default component.exports